<div
  class="sidebar-container"
  [class.closed]="!isOpen"
  (mouseenter)="onSidebarMouseEnter()"
  (mouseleave)="onSidebarMouseLeave()"
>
  <div *ngIf="isMobile" class="sidebar-closeButton">
    <button class="toggle-btn" (click)="toggleSidebar()">
      <i class="fa fa-arrow-left"></i>
    </button>
  </div>
  <div class="logo-container">
    <img
      src="assets/images/Logo/const-logo.svg"
      alt="Logo"
      class="logo"
      *ngIf="isOpen"
    />
  </div>
  <nav>
    <ng-container *ngFor="let item of visibleMenuItems">
      <div
        class="menu-item-hover-wrapper"
        [ngClass]="{
          'hover-expanded': item.isHovered && item.isParent && item.children,
          'single-item-hover': item.isHovered && !item.isParent,
        }"
        (mouseenter)="onMouseEnter(item)"
        (mouseleave)="onMouseLeave(item)"
      >
        <div *ngIf="item.isParent && item.children" class="menu-item-container">
          <div
            class="menu-item parent-item"
            (click)="toggleSubmenu(item)"
            [ngClass]="{
              'active-nav': isParentActive(item),
              expanded: item.isExpanded,
              hovered: item.isHovered,
            }"
          >
            <div class="menu-content">
              <img
                [src]="item.iconImagePath"
                alt="{{ item.label }}"
                class="sidebar-icon"
              />
              <span
                class="label"
                *ngIf="isOpen || (!isOpen && isHoveringAnyItem)"
                >{{ item.label }}</span
              >
            </div>
            <i
              *ngIf="isOpen || (!isOpen && isHoveringAnyItem)"
              class="fa fa-chevron-down chevron-icon"
              [ngClass]="{ rotated: item.isExpanded }"
            ></i>
          </div>

          <div
            class="submenu"
            *ngIf="
              item.children &&
              ((item.isExpanded && isOpen) ||
                (!isOpen && item.isHovered && isHoveringAnyItem))
            "
            [ngClass]="{
              expanded:
                (item.isExpanded && isOpen) ||
                (!isOpen && item.isHovered && isHoveringAnyItem),
            }"
            (mouseenter)="onSubmenuMouseEnter(item)"
            (mouseleave)="onSubmenuMouseLeave(item)"
          >
            <a
              *ngFor="let child of item.children"
              [routerLink]="child.route"
              class="submenu-item"
              [ngClass]="{ 'active-nav': isActive(child.route!) }"
              (click)="closeHoverOnClick(item)"
            >
              <img
                [src]="child.iconImagePath"
                alt="{{ child.label }}"
                class="sidebar-icon submenu-icon"
              />
              <span class="label">{{ child.label }}</span>
            </a>
          </div>
        </div>

        <a
          *ngIf="!item.isParent"
          [routerLink]="item.route"
          (click)="item.onClick?.()"
          class="menu-item single-item"
          [ngClass]="{
            'active-nav': isActive(item.route!),
            hovered: item.isHovered,
          }"
        >
          <img
            [src]="item.iconImagePath"
            alt="{{ item.label }}"
            class="sidebar-icon"
          />
          <span
            class="label"
            *ngIf="isOpen || (!isOpen && isHoveringAnyItem)"
            >{{ item.label }}</span
          >
        </a>
      </div>
    </ng-container>
  </nav>

  <div class="mascot" *ngIf="isOpen || (!isOpen && isHoveringAnyItem)">
    <div class="mascot-container">
      <img
        src="assets/images/Logo/CSQ-REV-logo.svg"
        alt="Mascot"
        class="mascot-img"
      />
      <div class="mascot-img-content">
        <a
          href="https://www.tiktok.com/@constructionpathways"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="mascot-icon-wrapper tiktok">
            <img
              src="assets/images/tiktok-logo.svg"
              alt="tiktok"
              class="mascot-icon"
            />
          </div>
        </a>
        <a
          href="https://www.instagram.com/constructionpathways/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="mascot-icon-wrapper instagram">
            <img
              src="assets/images/instagram-logo.svg"
              alt="instagram"
              class="mascot-icon"
            />
          </div>
        </a>
        <a
          href="https://www.facebook.com/constructionpathways"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="mascot-icon-wrapper facebook">
            <img
              src="assets/images/facebook-logo.svg"
              alt="facebook"
              class="mascot-icon"
            />
          </div>
        </a>
        <a
          href="https://constructionpathways.com.au/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="mascot-icon-wrapper web">
            <img
              src="assets/images/web-logo.svg"
              alt="web"
              class="mascot-icon"
            />
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
